// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._18u0u2gc{margin-left:var(--ds-space-100,8px)}\n._19bvidpf{padding-left:0}\n._19pku2gc{margin-top:var(--ds-space-100,8px)}\n._1e0c1txw{display:flex}\n._1n261g80{flex-wrap:wrap}\n._2hwxu2gc{margin-right:var(--ds-space-100,8px)}\n._otyridpf{margin-bottom:0}", ""]);
// Exports
module.exports = exports;
